import { AnyAction } from 'redux';

import { stationsActions } from '../reducer';

export const resetStationsPriceReport = (): AnyAction => stationsActions.resetStationsPriceReport();